var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$abilities.includes('update shipments'))?_c('v-alert',{attrs:{"value":_vm.show,"color":"red","type":"error"}},[_c('strong',[_vm._v(" Select a printer for attachments. "),_c('router-link',{attrs:{"to":"/settings"}},[_vm._v("Select printer »")])],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }